import { render } from "./Sector.vue?vue&type=template&id=466f95e2"
import script from "./Sector.vue?vue&type=script&lang=js"
export * from "./Sector.vue?vue&type=script&lang=js"
script.render = render

export default script